function transferTransformMatrix(matrix, toObject) {
    return toObject
        .matrix
        .getInverse(toObject.parent.matrixWorld)
        .multiply(matrix)
        .decompose(toObject.position, toObject.quaternion, toObject.scale);
}

function transferTransform(fromObject, toObject) {
    return transferTransformMatrix(fromObject.matrixWorld, toObject);
}

export default transferTransform;
export { transferTransformMatrix, transferTransform };